import axios from 'axios';
import { getApiBaseUrl, setupAxiosAuth } from '../utils/urlConfig';
import logger from '../utils/logger';

const API_BASE_URL = getApiBaseUrl();

const setupRequest = () => {
  setupAxiosAuth(axios);
};

/**
 * Fetch recent webhook events from the durable queue (webhook_events table).
 * @param {Object} opts
 * @param {number} [opts.limit=100] - Max rows
 * @param {string} [opts.status] - Filter by status: pending|processing|done|failed
 */
export const fetchWebhookEvents = async ({ limit = 100, status } = {}) => {
  try {
    setupRequest();
    logger.log(`Fetching webhook events (limit: ${limit}, status: ${status || 'all'})`);
    const params = { limit };
    if (status) params.status = status;
    const response = await axios.get(`${API_BASE_URL}/webhooks/events`, { params });
    return response.data;
  } catch (error) {
    logger.error('Error fetching webhook events:', error);
    throw error;
  }
};

/**
 * Fetch a single event with its full payload.
 */
export const fetchWebhookEventDetail = async (id) => {
  try {
    setupRequest();
    const response = await axios.get(`${API_BASE_URL}/webhooks/events/${id}`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching webhook event detail:', error);
    throw error;
  }
};

/**
 * Re-queue a failed (or done) webhook event for reprocessing.
 */
export const retryWebhookEvent = async (id) => {
  try {
    setupRequest();
    const response = await axios.post(`${API_BASE_URL}/webhooks/events/${id}/retry`);
    return response.data;
  } catch (error) {
    logger.error('Error retrying webhook event:', error);
    throw error;
  }
};
